export default __webpack_public_path__ + "static/audio-cardio-5-d-e127bd481dc4091d5be687de97e63808.webp";